export default [{
  path: '/view/companytemplates',
  name: 'companytemplates',
  component: () => import('@/app/company-templates/CompanyTemplates'),
  meta: {
    resource: 'companytemplates',
    actions: ['read']
  }
}]
